import React, {useState} from "react";
import StyledPage from "./StyledPage";
import "../style/admin-page.css";
import Bg from "../assets/faq-bg.png";
import {Tabs, Tab, Box} from "@mui/material";
import InquiryTable from "../components/InquiryTable";
import ApplyTable from "../components/ApplyTable";
import {useAdmin} from "../utils/AdminContext";

const AdminPage: React.FC = () => {
  const {isAdmin, loading, login, logout} = useAdmin();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };


  return (
    <StyledPage>
      <div className="admin-page">
        <img className="admin-bg" src={Bg} alt=""/>
        <div className="admin-page-title-1">블루스키스쿨</div>
        <div className="admin-page-title-2">ADMIN</div>

        {loading ? (<div className="admin-page-title-3">LOADING...</div>)
          : (
            <>
              {!isAdmin ? (
                <div className="admin-login-content">
                  <div className="admin-description">
                    어드민 페이지에 접근하려면 <br/> Google 로그인을 해주세요.
                  </div>
                  <button className="admin-button" onClick={login}>
                    Google 로그인
                  </button>
                </div>
              ) : (
                <div className="admin-accessed">
                  <div className={'admin-accessed-tabs'}>
                    <Box sx={{width: "100%"}}>
                      <Tabs
                        value={tabValue}
                        onChange={handleTabChange}
                        centered
                        indicatorColor="primary"
                        textColor="primary"
                        sx={{fontFamily: 'Pretendard-Regular, sans-serif'}}
                      >
                        <Tab label="실시간 문의 확인하기"/>
                        <Tab label="강습 신청 확인하기"/>
                      </Tabs>
                    </Box>
                    <button
                      className="admin-button"
                      onClick={logout}
                      disabled={loading}
                    >
                      로그아웃
                    </button>
                  </div>
                  {tabValue === 0 && (
                    <InquiryTable/>
                  )}
                  {tabValue === 1 && (
                    <ApplyTable/>
                  )}
                </div>
              )}
            </>
          )}
        {/*{!isAdmin ? (*/}
        {/*  <div className="admin-login-content">*/}
        {/*    <div className="admin-description">*/}
        {/*      어드민 페이지에 접근하려면 <br /> Google 로그인을 해주세요.*/}
        {/*    </div>*/}
        {/*    <button className="admin-button" onClick={login}>*/}
        {/*      Google 로그인*/}
        {/*    </button>*/}
        {/*  </div>*/}
        {/*) : (*/}
        {/*  <div className="admin-accessed">*/}
        {/*    <div className={'admin-accessed-tabs'}>*/}
        {/*      <Box sx={{width: "100%"}}>*/}
        {/*        <Tabs*/}
        {/*          value={tabValue}*/}
        {/*          onChange={handleTabChange}*/}
        {/*          centered*/}
        {/*          indicatorColor="primary"*/}
        {/*          textColor="primary"*/}
        {/*          sx={{fontFamily: 'Pretendard-Regular, sans-serif'}}*/}
        {/*        >*/}
        {/*          <Tab label="실시간 문의 확인하기"/>*/}
        {/*          <Tab label="강습 신청 확인하기"/>*/}
        {/*        </Tabs>*/}
        {/*      </Box>*/}
        {/*      <button*/}
        {/*        className="admin-button"*/}
        {/*        onClick={logout}*/}
        {/*        disabled={loading}*/}
        {/*      >*/}
        {/*        로그아웃*/}
        {/*      </button>*/}
        {/*    </div>*/}
        {/*    {tabValue === 0 && (*/}
        {/*      <InquiryTable/>*/}
        {/*    )}*/}
        {/*    {tabValue === 1 && (*/}
        {/*      <ApplyTable/>*/}
        {/*    )}*/}
        {/*  </div>*/}
        {/*)}*/}
      </div>
    </StyledPage>
  );
};

export default AdminPage;
